import { makeStyles } from '@material-ui/core';
import { useSearchModal } from '@backstage/plugin-search';
import { useLocation } from 'react-router-dom';
import {
  DocumentCleanIcon,
  GridIcon,
  HomeIcon,
  SearchIcon,
} from '../../components/icons';
import { MobileTabBarItem } from './MobileTabBarItem';
import type { MobileTab } from './types';

const useStyles = makeStyles({
  // Fixed bottom bar (mock 3a-3f). Sits above content; the shell reserves the
  // matching bottom padding so nothing hides behind it. `snackbar` z-index keeps
  // it above page content, matching Backstage's own MobileSidebar layering.
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1400,
    display: 'flex',
    background: 'var(--hone-portal-surface-frosted)',
    backdropFilter: 'saturate(180%) blur(8px)',
    borderTop: '1px solid var(--bui-border-1)',
    padding: '2px 8px',
    paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
  },
});

export const MOBILE_TAB_BAR_HEIGHT = 64;

// The mobile bottom tab bar: Home / Catalog / Docs / Search (mock 3a-3f).
// Search opens the shared search sheet rather than routing, so it is an action
// tab; the others route. Rendered only on the phone breakpoint by the shell.
export function MobileTabBar() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { state, toggleModal } = useSearchModal();

  const tabs: MobileTab[] = [
    {
      id: 'home',
      label: 'Home',
      icon: HomeIcon,
      to: '/',
      active: pathname === '/',
    },
    {
      id: 'catalog',
      label: 'Catalog',
      icon: GridIcon,
      to: '/catalog',
      active: pathname.startsWith('/catalog'),
    },
    {
      id: 'docs',
      label: 'Documentation',
      icon: DocumentCleanIcon,
      to: '/documentation',
      active: pathname.startsWith('/documentation'),
    },
    {
      id: 'search',
      label: 'Search',
      icon: SearchIcon,
      onClick: toggleModal,
      active: state.open,
    },
  ];

  return (
    <nav className={classes.root} aria-label="Primary">
      {tabs.map(tab => (
        <MobileTabBarItem key={tab.id} tab={tab} />
      ))}
    </nav>
  );
}
